import { useRef, useState } from "react";

function UserAppAccessTableRow({ key, appNames, fidesRoles, factbookRoles, fairRoles, idirtRoles, 
	cristalRoles, handleSubmit, setError, t, setAdd, oddIdx }) {
	const today = new Date().toISOString().split("T")[0];
	const [appRoles, setAppRoles] = useState({});
	const [appName, setAppName] = useState("");
	const [appRole, setAppRole] = useState("");
	const [subscriptionDate, setSubscriptionDate] = useState("");
	const [isSubmit, setIsSubmit] = useState(false);
	let selectedApp = "";
	let selectedAppRole = "";
	let selectedSubscriptionDate = "";
	const subscriptionDateRef = useRef(null);

	function appNameHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		selectedApp = e.target.value;
		if (selectedApp === "Fides") {
			setAppRoles(fidesRoles)
		} else if (selectedApp === "Factbook") {
			setAppRoles(factbookRoles)
		} else if (selectedApp === "FAIR") {
			setAppRoles(fairRoles)
		} else if (selectedApp === "iDirt") {
			setAppRoles(idirtRoles)
		} else if (selectedApp === "Cristal") {
			setAppRoles(cristalRoles)
		} else {
			setAppRoles({});
		}
		setAppName(selectedApp);
	}
	function appRoleHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		selectedAppRole = e.target.value;
		setAppRole(selectedAppRole);
	}
	function subscriptionDateHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		selectedSubscriptionDate = e.target.value;
		setSubscriptionDate(selectedSubscriptionDate);
	}
	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		setSubscriptionDate(subscriptionDateRef.current.value);
		let initialValues = {
			appName: appName,
			appRole: appRole,
			subscriptionDate: subscriptionDateRef.current.value
		};

		if (!appName || !appRole) {
			setError(t("error.appName.appRole.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<select id="appName" onChange={(e) => (appNameHandler(e))} value={appName} className="form-select" style={{ minWidth: "150px" }}>
					<option />
					{appNames.length > 0 && appNames.map((appNameObj, index1) => (
						(appNameObj.appName !== "Customer") &&
						<option
							value={appNameObj.appName}
						>
							{appNameObj.appDisplayName}
						</option>
					))}
				</select>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<select id="appRole" onChange={(e) => (appRoleHandler(e))} value={appRole} className="form-select" style={{ minWidth: "150px" }}>
					<option />
					{appRoles.length > 0 && appRoles.map((appRoleObj, index2) => (
						<option
							value={appRoleObj.roleCode}
						>
							{appRoleObj.description}
						</option>
					))}
				</select>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="date"
					name="subscriptionDate"
					id="subscriptionDate"
					value={subscriptionDate || today}
					min={today}
					className="form-control rounded-pill shadow-sm px-4 "
					ref={subscriptionDateRef}
					onChange={(e) => (subscriptionDateHandler(e))}
					style={{ maxWidth: "250px" }}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default UserAppAccessTableRow;